<template>
  <v-container color="primary" class="pa-4" style="max-width: 1280px;">
    <!-- Statistics Widgets -->
    <v-layout row wrap class="mb-4" v-if="statistics">
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center blue lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold blue--text text--darken-4">{{ statistics.total }}</div>
                    <div class="caption blue--text text--darken-2 font-weight-bold">Total Embarques</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center orange lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold orange--text text--darken-4">{{ statistics.en_planta }}</div>
                    <div class="caption orange--text text--darken-2 font-weight-bold">En Planta</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center red lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold red--text text--darken-4">{{ statistics.en_retraso }}</div>
                    <div class="caption red--text text--darken-2 font-weight-bold">En Retraso</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center purple lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold purple--text text--darken-4">{{ statistics.liberados }}</div>
                    <div class="caption purple--text text--darken-2 font-weight-bold">Liberados</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center green lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold green--text text--darken-4">{{ statistics.completados }}</div>
                    <div class="caption green--text text--darken-2 font-weight-bold">Completados</div>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>

    <!-- Calendar as main element -->
    <v-card class="rounded-lg elevation-4 overflow-hidden">
      <v-toolbar flat color="white" class="border-bottom mockup-toolbar">
        <v-icon color="primary" class="mr-3">event_available</v-icon>
        <v-toolbar-title class="headline font-weight-bold primary--text">
          Calendario de Ventanas de Embarques (Vista Informativa)
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch
          v-model="mostrarCancelados"
          label="Mostrar cancelados"
          hide-details
          class="ma-0 pa-0 mr-4"
        ></v-switch>
        <v-select
          v-if="enableAdvancedShipments"
          v-model="filtroTipoMovimiento"
          :items="[
            { text: 'Todos', value: 'TODOS' },
            { text: 'Solo Embarques', value: 'EMBARQUE' },
            { text: 'Solo Recepciones', value: 'RECEPCION' }
          ]"
          item-text="text"
          item-value="value"
          dense
          outlined
          hide-details
          class="ma-0 pa-0 mr-4"
          style="max-width: 180px; z-index: 100"
        ></v-select>
        <!-- Custom Input for minutes -->
        <div style="width: 100px; margin-right: 10px; margin-top: 5px;" class="d-flex align-center">
          <v-text-field
            v-model.number="refreshMinutes"
            label="Recarga (min)"
            type="number"
            min="1"
            dense
            outlined
            hide-details
            @change="updateRefreshInterval"
            title="Tiempo de recarga automático en minutos"
            color="primary"
          ></v-text-field>
        </div>
        <v-btn icon color="primary" @click="scrollToCurrentTime" class="ml-2" title="Ir a hora actual">
          <v-icon>my_location</v-icon>
        </v-btn>
        <v-btn icon color="primary" @click="fillCalendars(currentDate, currentDate)" :loading="loadingShippingWindows" class="ml-2">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn icon color="primary" @click="toggleFullscreen" class="ml-2">
          <v-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pa-6">
        <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
          <div class="d-flex align-center">
            <v-btn small depressed color="primary lighten-4" @click="goPrev()" :loading="loadingShippingWindows" class="mr-2">
              <v-icon color="primary">chevron_left</v-icon>
            </v-btn>
            <v-menu
              ref="menuVentana2"
              v-model="menuVentana2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              :z-index="2000"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="date-display px-4 py-2 rounded-pill lighten-5 primary--text font-weight-bold pointer d-flex align-center" v-bind="attrs" v-on="on">
                  <v-icon color="primary">calendar_today</v-icon>
                  {{ form.fechaVentana }}
                </div>
              </template>
              <v-date-picker
                ref="picker"
                v-model="form.fechaVentana"
                :locale="$t('region')"
                @change="saveDate"
                @input="menuVentana2 = false"
                color="primary"
              />
            </v-menu>

            <v-btn small depressed color="primary lighten-4" @click="goNext" :loading="loadingShippingWindows" class="ml-2">
              <v-icon color="primary">chevron_right</v-icon>
            </v-btn>
          </div>

          <div class="legend d-flex align-center mt-2 mt-sm-0 flex-wrap">
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box programada-event mr-2"></div>
              <span class="caption font-weight-medium">Programada</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box confirmada-event mr-2"></div>
              <span class="caption font-weight-medium">Confirmada</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box ensitio-event mr-2"></div>
              <span class="caption font-weight-medium">En Sitio</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box enproceso-event mr-2"></div>
              <span class="caption font-weight-medium">En Proceso</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box liberada-event mr-2"></div>
              <span class="caption font-weight-medium">Liberada</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box completada-event mr-2"></div>
              <span class="caption font-weight-medium">Completada</span>
            </div>
            <div class="legend-item d-flex align-center mb-2">
              <div class="legend-box cancelada-event mr-2"></div>
              <span class="caption font-weight-medium">Cancelada</span>
            </div>
          </div>
        </div>

        <div class="calendar-container-wrapper">
          <v-row no-gutters class="calendar-grid">
            <v-col v-for="(item, index) in calendars" :key="index" class="calendar-column border-right border-left">
              <div class="calendar-header-title py-3 text-center primary--text font-weight-bold border-bottom">
                {{ item.name }}
              </div>
              <v-calendar
                ref="calendarwe"
                v-model="currentDate"
                hide-header
                :value="today"
                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                type="day"
                :locale="$t('region')"
                :interval-minutes="30"
                :interval-count="numberSlots"
                :first-interval="0"
                :events="item.events"
                :interval-format="intervalFormat"
                @click:time="agregarNewEventoToCalendar($event, index, item.id)"
                class="custom-calendar-style"
              >
                <template v-slot:interval="{ hour, minute }">
                  <div class="interval-label text-center caption grey--text text--darken-1">
                    {{ hour.toString().padStart(2, '0') }}:{{ minute.toString().padStart(2, '0') }}
                  </div>
                </template>
                <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                  <template v-for="event in eventsMap[index][date]">
                    <v-tooltip v-if="shouldShowEvent(event)" bottom :key="event.id + '-' + event.time">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          :class="[
                            'my-event-folder',
                            'with-time',
                            getMovementClass(event)
                          ]"
                          :style="{
                            top: timeToY(event.time) + 'px',
                            height: minutesToPixels(event.duration) + 'px',
                            borderLeftColor: getMovementBorderColor(event),
                            borderLeftWidth: '4px'
                          }"
                          @click="open(event)"
                        >
                          <div :class="['folder-tab', getStatusClass(event.title)]">
                            <v-icon v-if="event.title === 'COMPLETADA'" x-small color="white" class="mr-1" style="font-size: 12px;">done_all</v-icon>
                            <v-icon v-else-if="event.title === 'EN_PROCESO'" x-small color="white" class="mr-1" style="font-size: 12px;">pending</v-icon>
                            <!-- REQ-002: Indicadores visuales de tipo de movimiento -->
                            <v-icon
                              v-else-if="enableAdvancedShipments && event.tipo_movimiento === 'EMBARQUE'"
                              x-small
                              color="white"
                              class="mr-1"
                              style="font-size: 12px;"
                              title="Embarque (Salida)"
                            >
                              arrow_upward
                            </v-icon>
                            <v-icon
                              v-else-if="enableAdvancedShipments && event.tipo_movimiento === 'RECEPCION'"
                              x-small
                              color="white"
                              class="mr-1"
                              style="font-size: 12px;"
                              title="Recepción (Entrada)"
                            >
                              arrow_downward
                            </v-icon>
                            <span class="folder-tab-text">{{ event.title }}</span>
                            <v-tooltip top v-if="(event.title === 'EN_PROCESO' || event.title === 'LIBERADA') && isTimeExceeded(event)">
                              <v-icon slot="activator" x-small color="red accent-2" class="ml-1 blink-alert" style="font-size: 14px;">warning</v-icon>
                              <span>¡Tiempo de carga excedido!</span>
                            </v-tooltip>
                            <v-tooltip top v-if="enableAdvancedShipments && hasPendingDocuments(event)">
                              <v-icon slot="activator" x-small color="amber darken-2" class="ml-1" style="font-size: 14px;">description</v-icon>
                              <span>Documentos pendientes</span>
                            </v-tooltip>
                          </div>
                            <div :class="['folder-body', getStatusClass(event.title)]">
                            <div class="folder-content" style="display: flex; flex-direction: column; height: 100%; justify-content: space-between; text-align: left; gap: 8px;">
                              <!-- REQ-002: Etiqueta de tipo de movimiento -->
                              <div v-if="enableAdvancedShipments && event.tipo_movimiento" class="d-flex align-center gap-1 flex-wrap">
                                <v-chip
                                  x-small
                                  :color="getStatusColor(event.title)"
                                  text-color="white"
                                  label
                                  class="chip-tipo-movimiento"
                                >
                                  <v-icon x-small left class="mr-1">{{ event.tipo_movimiento === 'EMBARQUE' ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                                  {{ event.tipo_movimiento === 'EMBARQUE' ? 'Embarque' : 'Recepción' }}
                                </v-chip>
                                <v-chip
                                  v-if="event.is_internal"
                                  x-small
                                  color="success"
                                  text-color="white"
                                  label
                                  title="Asignación Interna"
                                  class="chip-tipo-movimiento"
                                >
                                  <v-icon x-small left class="mr-1">check_circle</v-icon>
                                  Interno
                                </v-chip>
                              </div>
                              <div class="event-client-name font-weight-bold" v-if="event.client_name" style="font-size: 1rem; line-height: 1.2; word-break: break-word;">
                                {{ event.client_name }}
                              </div>
                              <div v-if="event.invited_company" class="caption" style="opacity: 0.85; font-size: 0.80rem; font-style: italic; word-break: break-word;">
                                {{ event.invited_company }}
                              </div>
                              <div class="caption mt-auto pt-1 font-weight-medium" style="opacity: 0.95; font-size: 0.90rem;">
                                {{ event.time }} <span v-if="event.duration">({{ event.duration }} min)</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <span>{{ event.title }} ({{ event.time }})<span v-if="event.client_name"> - {{ event.client_name }}</span></span>
                    </v-tooltip>
                  </template>
                </template>
              </v-calendar>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

    </v-card>


    <v-dialog v-model="dialogCalendario" max-width="1200px">
      <v-card>
        <v-toolbar dark color="primary" class="mockup-toolbar">
            <v-toolbar-title>
                Calendario por Día 
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <p class="text-xs-center mt-4">Vista detallada del calendario</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogCalendario = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogEventDetails" max-width="450px" v-if="selectedEvent">
      <v-card class="rounded-xl elevation-8 overflow-hidden">
        <v-toolbar flat dark :class="getToolbarClass(selectedEvent.title)" class="premium-toolbar mockup-toolbar">
          <v-icon left>info</v-icon>
          <v-toolbar-title class="font-weight-bold">Detalle de la Ventana</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEventDetails = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6 mt-2" style="max-height: 65vh; overflow-y: auto;">
          <v-layout column>
            <v-flex class="mb-4 text-center">
              <v-chip
                :class="getMovimientoChipClass(selectedEvent.title)"
                label
                class="px-4 font-weight-bold headline mb-2"
                style="height: auto; padding: 12px 20px; border-radius: 12px;"
              >
                <v-icon left small class="mr-2">{{ getStatusIcon(selectedEvent.title) }}</v-icon>
                {{ getStatusDisplay(selectedEvent.title) }}
              </v-chip>
              <div class="grey--text text--darken-1 font-weight-medium caption mt-1">Estado de la Ventana</div>
              <div v-if="enableAdvancedShipments && selectedEvent.tipo_movimiento" class="mt-4">
                <v-chip
                  :color="getStatusColor(selectedEvent.title)"
                  text-color="white"
                  label
                  class="px-4 font-weight-bold"
                  style="height: auto; padding: 8px 16px; border-radius: 12px;"
                >
                  {{ selectedEvent.tipo_movimiento === 'EMBARQUE' ? 'Embarque (Salida)' : 'Recepción (Entrada)' }}
                </v-chip>
                <div class="caption grey--text text--darken-1 font-weight-medium mt-2">Tipo de Movimiento</div>
              </div>
            </v-flex>

            <v-divider class="mb-5"></v-divider>

            <v-layout row wrap class="info-grid overflow-hidden">
              <v-flex xs6 class="mb-4 pr-2">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">calendar_today</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Fecha</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.date.split('-').reverse().join('/') }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">access_time</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Hora</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.time }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pr-2" v-if="selectedEvent.client_name || selectedEvent.client">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">person</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Cliente</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.client_name || selectedEvent.client }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2" v-if="selectedEvent.transport_type_name || selectedEvent.transport_type">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">local_shipping</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Transporte</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.transport_type_name || selectedEvent.transport_type }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pr-2">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">timer</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Duración</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.duration }} min</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">forklift</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Área de Carga</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.loading_area_name }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2" v-if="selectedEvent.company_name || selectedEvent.empresa">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">business</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Empresa</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.company_name || selectedEvent.empresa }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pr-2" v-if="selectedEvent.invited_company">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">local_shipping</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Línea del Transportista</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.invited_company }}</div>
                  </div>
                </div>
              </v-flex>
               <!-- Información de Carga (Status EN_PROCESO, LIBERADA o COMPLETADA) -->
              <v-flex xs12 v-if="(selectedEvent.title === 'EN_PROCESO' || selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA') && currentLoad" class="mt-2">
                <v-divider class="mb-4"></v-divider>
                <v-layout row wrap>
                   <v-flex xs6 class="mb-4 pr-2">
                    <div class="d-flex align-start">
                      <v-icon color="orange" class="mr-3">play_circle_filled</v-icon>
                      <div class="flex-grow-1">
                        <div class="caption grey--text font-weight-bold text-uppercase">Inicio de Carga</div>
                        <div class="body-2 font-weight-bold orange--text">{{ currentLoad.start_time ? new Date(currentLoad.start_time).toLocaleTimeString() : 'N/A' }}</div>
                      </div>
                    </div>
                  </v-flex>

                  <v-flex xs6 class="mb-4 pl-2" v-if="selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA'">
                    <div class="d-flex align-start">
                      <v-icon :color="selectedEvent.title === 'COMPLETADA' ? 'success' : 'purple'" class="mr-3">stop_circle</v-icon>
                      <div class="flex-grow-1">
                        <div class="caption grey--text font-weight-bold text-uppercase">Fin de Carga</div>
                        <div class="body-2 font-weight-bold mb-2" :class="selectedEvent.title === 'COMPLETADA' ? 'success--text' : 'purple--text'">{{ currentLoad.end_time ? new Date(currentLoad.end_time).toLocaleTimeString() : 'N/A' }}</div>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>


                <div v-if="selectedEvent.title === 'EN_PROCESO'" class="mt-4 px-1">
                  <v-text-field
                    v-model="formCarga.payroll_number"
                    label="Número de Nómina"
                    outlined
                    dense
                    prepend-inner-icon="badge"
                    color="primary"
                    placeholder="Ingrese número de nómina"
                    :error-messages="payrollError"
                    @input="payrollError = ''"
                  ></v-text-field>

                  <v-textarea
                    v-model="formCarga.notes"
                    label="Notas de Carga"
                    outlined
                    dense
                    rows="2"
                    prepend-inner-icon="description"
                    color="primary"
                    placeholder="Ingrese observaciones sobre la carga"
                  ></v-textarea>
                </div>

                <!-- Resumen de Carga (Status LIBERADA o COMPLETADA) -->
                <v-card v-if="(selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA') && currentLoad" flat color="blue-grey lighten-5" class="rounded-lg pa-4 mb-4" style="border: 1px dashed #cfd8dc !important;">
                  <div class="caption blue-grey--text font-weight-bold text-uppercase mb-3 d-flex align-center">
                    <v-icon x-small color="blue-grey" class="mr-2">assignment</v-icon>
                    Resumen de Operación
                  </div>
                  <v-layout column>
                    <v-flex v-if="currentLoad.payroll_number || currentLoad.double_verification_employee_number" class="mb-3">
                      <div class="d-flex align-center">
                        <v-avatar tile size="28" color="white" class="mr-3 elevation-1">
                          <v-icon small color="primary">badge</v-icon>
                        </v-avatar>
                        <div>
                          <div class="caption grey--text font-weight-bold text-uppercase" style="font-size: 0.65rem !important; line-height: 1;">Nómina Verificador</div>
                          <div class="body-2 font-weight-bold primary--text">{{ currentLoad.payroll_number || currentLoad.double_verification_employee_number }}</div>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex v-if="currentLoad.notes">
                      <div class="d-flex align-start">
                        <v-avatar tile size="28" color="white" class="mr-3 elevation-1">
                          <v-icon small color="primary">description</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="caption grey--text font-weight-bold text-uppercase" style="font-size: 0.65rem !important; line-height: 1;">Notas de Carga</div>
                          <div class="body-2 font-weight-medium mt-1 grey--text text--darken-4" style="line-height: 1.4;">
                            {{ currentLoad.notes }}
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>

                <div v-if="currentLoad.evidence && currentLoad.evidence.length > 0">
                  <div class="caption grey--text font-weight-bold text-uppercase mb-3 ml-1">Evidencias:</div>
                  <v-list dense class="bg-transparent pa-0">
                    <v-card v-for="ev in currentLoad.evidence" :key="ev.id" class="mb-2 elevation-1" style="border: 1px solid rgba(0, 0, 0, 0.08); border-radius: 8px;">
                      <v-list-tile avatar>
                        <v-list-tile-avatar color="primary lighten-5" size="36px">
                          <v-icon small color="primary">{{ ev.file.endsWith('.pdf') ? 'picture_as_pdf' : 'image' }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="body-1 font-weight-medium grey--text text--darken-4">
                            {{ ev.description }}
                          </v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action class="flex-row align-center">
                          <v-tooltip top>
                            <v-btn slot="activator" icon small :href="ev.file" target="_blank" class="mr-1">
                              <v-icon small color="primary">visibility</v-icon>
                            </v-btn>
                            <span>Ver evidencia</span>
                          </v-tooltip>

                        </v-list-tile-action>
                      </v-list-tile>
                    </v-card>
                  </v-list>
                </div>
              </v-flex>

              <v-flex xs12 class="mt-2" v-if="selectedEvent.observations">
                <v-divider class="mb-4"></v-divider>
                <div class="d-flex align-start">
                  <v-icon color="primary" class="mr-3">notes</v-icon>
                  <div class="w-100">
                    <div class="caption grey--text font-weight-bold text-uppercase">Observaciones</div>
                    <div class="body-2 font-weight-medium bg-white pa-3 rounded-lg border-light mt-1">
                      {{ selectedEvent.observations }}
                    </div>
                  </div>
                </div>
              </v-flex>

              <!-- Documentos Solicitados (Fusionados) -->
              <v-flex xs12 class="mt-4" v-if="selectedEvent && selectedEvent.required_documents && selectedEvent.required_documents.length > 0">
                <v-divider class="mb-4"></v-divider>
                <div class="d-flex align-start">
                  <v-icon color="primary" class="mr-3">description</v-icon>
                  <div class="w-100">
                    <div class="caption grey--text font-weight-bold text-uppercase mb-3">
                      Documentos Requeridos
                      <span v-if="getPendingDocuments().length > 0" class="amber--text darken-2--text">
                        ({{ getPendingDocuments().length }} pendiente{{ getPendingDocuments().length !== 1 ? 's' : '' }})
                      </span>
                    </div>
                    <v-layout column>
                      <v-flex v-for="doc in documentComparison" :key="doc.id" class="mb-3">
                        <div class="d-flex align-center justify-space-between pa-3 rounded-lg border-light" :style="{ backgroundColor: (doc.status === 'PENDIENTE' || doc.status === 'EXPIRADO') ? '#fff3e0' : '#f5f5f5', borderLeft: (doc.status === 'PENDIENTE' || doc.status === 'EXPIRADO') ? '4px solid #FFA000' : '4px solid #4CAF50' }">
                          <div class="d-flex align-center flex-grow-1">
                            <v-icon
                              :color="doc.status === 'VIGENTE' ? 'success' : (doc.status === 'EXPIRADO' ? 'error' : 'amber darken-2')"
                              small
                              class="mr-2"
                            >
                              {{ doc.status === 'VIGENTE' ? 'check_circle' : (doc.status === 'EXPIRADO' ? 'error_outline' : 'schedule') }}
                            </v-icon>
                            <div>
                              <div class="caption font-weight-bold">{{ doc.name }}</div>
                              <div v-if="doc.status === 'PENDIENTE' && doc.guest_name === 'Sin asignar'" class="caption amber--text darken-2--text font-weight-bold">Pendiente de subir</div>
                              <div v-else class="caption grey--text">{{ doc.guest_name }}<span v-if="doc.guest_email"> - {{ doc.guest_email }}</span></div>
                              <div v-if="doc.valid_until && doc.status === 'EXPIRADO'" class="caption error--text">
                                ⚠️ Venció: {{ new Date(doc.valid_until).toLocaleDateString() }}
                              </div>
                              <div v-if="doc.valid_until && doc.status === 'VIGENTE'" class="caption success--text">
                                ✓ Vence: {{ new Date(doc.valid_until).toLocaleDateString() }}
                              </div>
                            </div>
                          </div>
                          <v-chip
                            small
                            :color="doc.status === 'VIGENTE' ? 'success' : (doc.status === 'EXPIRADO' ? 'error' : 'amber')"
                            text-color="white"
                            label
                            class="ml-2"
                          >
                            {{ doc.status }}
                          </v-chip>
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </v-flex>

              <v-flex xs12 class="mt-4" v-if="selectedEvent.administrador || selectedEvent.admin_email">
                <div class="d-flex align-center bg-primary lighten-5 pa-2 rounded-pill pr-4">
                  <v-avatar size="32" color="primary" class="mr-3">
                    <v-icon dark small>admin_panel_settings</v-icon>
                  </v-avatar>
                  <div class="caption primary--text font-weight-bold">
                    Admin: <span class="font-weight-medium">{{ selectedEvent.administrador || selectedEvent.admin_email }}</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>

            <v-alert
              v-if="selectedEvent.title === 'CANCELADA'"
              type="error"
              outline
              color="red"
              class="rounded-lg mt-2"
              icon="block"
            >
              Esta reservación ha sido cancelada.
            </v-alert>
            <v-alert
              v-if="selectedEvent.title === 'PROGRAMADA'"
              type="info"
              outline
              color="blue"
              class="rounded-lg mt-2"
              icon="event_note"
            >
              Esta es una ventana programada pendiente de confirmación.
            </v-alert>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 bg-light">
          <v-layout row wrap fill-height align-center style="width: 100%">
            <v-flex xs12>
              <v-btn block depressed large color="grey lighten-2" class="text-none font-weight-bold" @click="dialogEventDetails = false" style="border-radius: 12px;">
                Cerrar Ventana
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import JSPDF from 'jspdf'
import '@/plugins/axios'
import store from '@/store'
import {mapGetters, mapState} from 'vuex'

export default {
  data: () => ({
    valid: true,
    menu: false,
    today: new Date().toLocaleDateString(), // '2025-03-31',
    menuVentana: false,
    menuVentana2: false,
    menuVentanaRecurrente: false,
    dialogClientes: false,
    dialogVentana: false,
    dialogCalendario: false,
    eventos: [
        {        
            title: 'PROGRAMADA',
            date: '2025-06-23',
            time: '01:30',
            duration: 30,
        },
        {        
            title: 'EN_PROCESO',
            date: '2025-06-23',
            time: '02:00',
            duration: 30,
        }
    ],
    selected: new Date().toLocaleDateString(), // '2025-03-31',
    documentos: [],
    diasSemana: [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo'
    ],
    form: {
      opciones: [],
      fecha: '',
      fechaVentana: '',
      fechaVentanaRecurrente: '',
      hora: '',
      dias: [],
      documentos: [],
      personas: [],
      areas: null,
      client: '',
      address: '',
      loading_time_minutes: '',
      typeTransport: '',
      notas: '',
      empresa: '',
      administrador: ''
    },
    chargeAreas: [],
    clients: [],
    client: {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
    },
    typesOfTransports: [],
    empresas: [
      { id: 1, nombre: 'Transportes y Logística S.A.' },
      { id: 2, nombre: 'Logística Integral S.A. de C.V.' },
      { id: 3, nombre: 'Transporte Express S.A.' },
      { id: 4, nombre: 'Servicios de Carga Rápida S.A.' },
      { id: 5, nombre: 'Logística Avanzada S.A. de C.V.' }
    ],
    administradores: [],
    timeInterval: 10,
    numberSlots: 48,
    disabledCalendar: true,
    disabledCalendar2: true,
    disabledCalendar3: true,
    disabledCalendar4: true,
    disabledCalendar5: true,
    disabledCalendar6: true,
    calendars: [],
    id_empresa: '',
    currentDate: null,
    loadingShippingWindows: false,
    id_empresa_empresarial: '',
    admin: {},
    isLoading_empresas: false,
    bandSinAdministrador: false,
    entries2: [],
    search: null,
    errores: [],
    loadingInvitacion: false,
    bandDeleteEvent: false,
    documentationsByCompany: [],
    dialogEventDetails: false,
    filtroTipoMovimiento: 'TODOS',
    dialogEvidencias: false,
    fileName: '',
    formEvidencia: {
      file: null,
      description: ''
    },
    loadingEvidencia: false,
    shipment_load_id: null,
    currentLoad: null,
    formCarga: {
      payroll_number: '',
      notes: ''
    },
    payrollError: '',
    selectedEvent: null,
    statistics: null,
    dialogSendEvidence: false,
    evidenceEmailInput: '',
    loadingSendEvidence: false,
    refreshIntervalId: null,
    isFullscreen: false,
    refreshMinutes: 2,
    mostrarCancelados: true,
    // REQ-006: Documentos requeridos en embarques
    requiredDocuments: [],
    userDocuments: [],
    loadingDocuments: false,
    documentComparison: []
  }),
  created: function(){
    this.get_extra_data()
    const now = new Date();
    this.currentDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`; // Local YYYY-MM-DD
    this.form.fechaVentana = this.currentDate
  },
  mounted() {
    this.startAutoRefresh();
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
  },
  beforeDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    if (this.isFullscreen && document.exitFullscreen) {
      document.exitFullscreen().catch(()=>{});
    }
    const appContainerEl = document.getElementById('app');
    if (appContainerEl) {
      appContainerEl.classList.remove('hide-layout-elements-fullscreen');
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    enableAdvancedShipments() {
      return this.getProfile && this.getProfile.enable_advanced_shipments === true
    },
    fields () {
      if (!this.id_empresa_empresarial) return []
      return Object.keys(this.id_empresa_empresarial).map(key => {
        return {
          key,
          value: this.id_empresa_empresarial[key] || 'n/a'
        }
      })
      },
      items () {
        return this.entries2.map(entry => {
          const name = entry.name.length > this.descriptionLimit
              ? entry.name.slice(0, this.descriptionLimit) + '...'
              : entry.name

          return Object.assign({}, entry, { name })
        })          
      },
      // convert the list of events into a map of lists keyed by date
      eventsMap () {
        let algo = []
        for (let i = 0; i < this.calendars.length; i++) {  
          const map = {}
          const events = this.mostrarCancelados
            ? (this.calendars[i].events || [])
            : (this.calendars[i].events || []).filter(e => e.title !== 'CANCELADA');
          events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
          algo.push(map)
        }
        return algo
      }
  },
  watch: {
      isUpdating (val) {
        if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
        }
      },
      search (val) {
        console.log(val)
        if (val !== null && val !== undefined) {
          if (val.length > 2) {
            this.isLoading_empresas = true
            const config = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/empresas/filter?search=' + val,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            };
            axios(config)
              .then(response => {
                console.log(response.data)
                if (this.entries2.length > 0) {
                  for (var i = 0; i < response.data.length; i++) {
                    this.entries2.push(response.data[i])
                  }
                } else
                  this.entries2 = response.data
              })
              .catch(error => {
                console.log(error)
              })
              .finally(() => (this.isLoading_empresas = false))
          }
        }
      },
      filtroTipoMovimiento(newVal) {
        if (this.enableAdvancedShipments) {
          this.calendars = []
          this.getChargeAreas()
        }
      }
  },
  methods: {
    getStatistics() {
        if (!this.id_empresa) return; // Wait for company ID
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/shipments/statistics/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            params: {
                empresa_id: this.id_empresa,
                period: 'day',
                date: this.currentDate || moment().format('YYYY-MM-DD')
            }
        };
        axios(config)
            .then(response => {
                this.statistics = response.data.statistics;
            })
            .catch(error => {
                console.log(error);
            });
    },
    customFilterAdministradores (item, queryText) {
      const textOne = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    get_name_company(){
      for(var i = 0 ; i < this.entries2.length ; i++){
        if(this.entries2[i].id === this.id_empresa_empresarial) {
          return this.entries2[i].name
        }
      }
    },
    async fillCalendars (start_date, end_date) {
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: start_date,
            end_date: end_date,
            empresa: this.id_empresa
          }
      };
      try {
        const response = await axios(config)
        const windows = response.data
        if (this.calendars.length > 0) {
          for (let i= 0; i< this.calendars.length ;i ++)
            this.calendars[i].events = []
          // Parallel fetch for EN_PROCESO and LIBERADA loads
          const targetWindows = windows.filter(w => w.status === 'EN_PROCESO' || w.status === 'LIBERADA')
          const loadPromises = targetWindows.map(w => this.fetchShipmentLoadData(w.id))
          const loads = await Promise.all(loadPromises)
          const loadsMap = {}
          targetWindows.forEach((win, index) => {
            if (loads[index]) {
              loadsMap[win.id] = loads[index]
            }
          })

          for (let i = 0; i < this.calendars.length; i ++) {
            for (let j = 0; j < windows.length; j++) {
              if(windows[j].loading_area === this.calendars[i].id) {
                const invitedCompanyName = windows[j].invitations && windows[j].invitations.length > 0 && windows[j].invitations[0].invited_company
                  ? windows[j].invitations[0].invited_company.name
                  : null

                this.calendars[i].events.push(
                  {
                    ...windows[j],
                    loading_area_name: this.calendars[i].name,
                    title: windows[j].status,
                    date: windows[j].window_date,
                    time: windows[j].window_time,
                    duration: windows[j].loading_time_minutes,
                    color: this.getStatusColor(windows[j].status),
                    id: windows[j].id,
                    new: false,
                    invited_company: invitedCompanyName,
                    start_time: (loadsMap[windows[j].id] || {}).start_time,
                    end_time: (loadsMap[windows[j].id] || {}).end_time
                  }
                )
              }
            }
          }
        }
        this.loadingShippingWindows = false
        // Scroll to current time after rendering
        this.$nextTick(() => {
          this.scrollToCurrentTime();
        });
      } catch (error) {
          console.log(error)
          this.loadingShippingWindows = false
      }
    },
    saveDate (date) {
      this.currentDate = date
      this.fillCalendars(this.currentDate, this.currentDate)
      this.getStatistics()
      this.form.fechaVentana = date
    },
    goNext() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() + 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      this.getStatistics()
      console.log('Fecha == ', this.currentDate)
    },
    goPrev() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() - 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      this.getStatistics()
      console.log('Fecha == ', this.currentDate)
    },
    startAutoRefresh() {
      if (this.refreshIntervalId) {
        clearInterval(this.refreshIntervalId);
      }
      const savedMinutes = localStorage.getItem('mockup4_refresh_minutes');
      if (savedMinutes) {
        this.refreshMinutes = parseInt(savedMinutes, 10);
      }
      const minutes = this.refreshMinutes && this.refreshMinutes > 0 ? this.refreshMinutes : 2;
      const ms = minutes * 60000;
      this.refreshIntervalId = setInterval(() => {
        if (!this.dialogEventDetails) { // Avoid refreshing while a dialog is open
          console.log(`Auto-refreshing dashboard data... (${minutes} min)`);
          this.getStatistics();
          this.fillCalendars(this.currentDate, this.currentDate);
        }
      }, ms)
    },
    updateRefreshInterval() {
      if (this.refreshMinutes && this.refreshMinutes > 0) {
        localStorage.setItem('mockup4_refresh_minutes', this.refreshMinutes);
        this.startAutoRefresh();
      }
    },
    scrollToCurrentTime() {
      const calendarContainer = this.$el.querySelector('.calendar-container-wrapper');
      if (calendarContainer) {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const totalMinutes = hours * 60 + minutes;
        

        const pixelsPerMinute = 1.33; 
        const scrollToY = (totalMinutes * pixelsPerMinute) - 60;
        
        calendarContainer.scrollTo({
          top: Math.max(0, scrollToY),
          behavior: 'smooth'
        });
      }
    },
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(err => {
          console.log(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        });
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
      
      const appContainerEl = document.getElementById('app');
      if (appContainerEl) {
        if (this.isFullscreen) {
         appContainerEl.classList.add('hide-layout-elements-fullscreen');
        } else {
         appContainerEl.classList.remove('hide-layout-elements-fullscreen');
        }
      }
    },
    get_extra_data (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/auth/me',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          }
      };
      axios(config)
          .then(response => {
            this.id_empresa = response.data.id_company
            this.getStatistics()
            this.getChargeAreas()
            this.getClients()
            this.getTypesOfTransports()
          })
          .catch(error => {
              console.log(error)
          })
    },
    createVCalendars (datos) {
      for (let i = 0; i < datos.length; i++){
        this.calendars.push(
          {
            id: datos[i].id,
            name: datos[i].name,
            focus: "",
            events: []
          }
        )
      }
    },
    getChargeAreas (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/charge-areas/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
              IdEmpresa: this.id_empresa,
              is_active: true
          }
      };
      axios(config)
          .then(response => {
              this.chargeAreas = response.data
              let areasToDisplay = response.data

              if (this.enableAdvancedShipments && this.filtroTipoMovimiento !== 'TODOS') {
                areasToDisplay = response.data.filter(area => {
                  if (!area.operation_type) return true
                  if (this.filtroTipoMovimiento === 'EMBARQUE') {
                    return area.operation_type === 'EMBARQUE' || area.operation_type === 'AMBOS'
                  } else if (this.filtroTipoMovimiento === 'RECEPCION') {
                    return area.operation_type === 'RECEPCION' || area.operation_type === 'AMBOS'
                  }
                  return true
                })
              }

              this.createVCalendars(areasToDisplay)
              this.fillCalendars(this.currentDate, this.currentDate)
          })
          .catch(error => {
              console.log(error)
          })
    },
    getClients () {
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/clients/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            params: {
                empresa: this.id_empresa,
                is_active: true
            }
        };
        axios(config)
            .then(response => {
                this.clients = response.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    getTypesOfTransports (){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/carrier-types/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          IdEmpresa: this.id_empresa,
          is_active: true
        }
      };
      axios(config)
      .then(response => {
          this.typesOfTransports = response.data
      })
      .catch(error => {
          console.log(error)
      })
    },
    limpiarFormulario() {
      this.client = {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
      }
      this.valid = false
    },
    async open (event) {
      this.selectedEvent = event
      this.currentLoad = null
      this.payrollError = ''
      this.dialogEventDetails = true

      if (event.title === 'PROGRAMADA') {
        this.form.hora = event.time
        this.bandDeleteEvent = false
      }

      if (event.title === 'EN_PROCESO' || event.title === 'LIBERADA' || event.title === 'COMPLETADA') {
        await this.fetchShipmentLoadData(event.id)
      }

      // REQ-006: Cargar TODOS los documentos desde required_documents
      console.log('=== CARGANDO DOCUMENTOS ===')
      console.log('enableAdvancedShipments:', this.enableAdvancedShipments)
      console.log('required_documents:', event.required_documents)

      if (this.enableAdvancedShipments && event.required_documents && event.required_documents.length > 0) {
        this.documentComparison = []

        // Iterar sobre required_documents y sus usuarios
        event.required_documents.forEach((doc) => {
          console.log(`Documento: ${doc.name}`, doc.completion_by_user)

          if (doc.completion_by_user && Object.keys(doc.completion_by_user).length > 0) {
            // Para cada usuario que tiene este documento
            Object.keys(doc.completion_by_user).forEach(userId => {
              const userDoc = doc.completion_by_user[userId]
              console.log(`  Usuario ${userDoc.user.name} - Status: ${userDoc.status}`)

              this.documentComparison.push({
                id: doc.id || Math.random().toString(),
                name: doc.name,
                status: userDoc.status,
                valid_until: userDoc.valid_until || null,
                uploaded_at: userDoc.uploaded_at || null,
                uploaded: userDoc.uploaded || false,
                guest_name: userDoc.user.name,
                guest_email: userDoc.user.email,
                required: doc.required
              })
            })
          } else {
            // Si no hay usuarios aún, mostrar el documento como solicitado/pendiente
            this.documentComparison.push({
              id: doc.id || Math.random().toString(),
              name: doc.name,
              status: 'PENDIENTE',
              valid_until: null,
              uploaded_at: null,
              uploaded: false,
              guest_name: 'Sin asignar',
              guest_email: '',
              required: doc.required
            })
          }
        })

        console.log('✅ Documentos cargados total:', this.documentComparison.length)
      } else {
        console.log('❌ No se cargaron documentos')
        this.documentComparison = []
      }

      console.log('=== FIN CARGA DOCUMENTOS ===')
      console.log('documentComparison final:', this.documentComparison)

      console.log('Información del Evento Destapada:', event)
    },
    onClickInterval(interval) {
      console.log('Intervalo seleccionado:', interval)
    },

    intervalFormat (interval) {
      // devuelve “00:00, 01:00, … 23:00”
      return interval.time         // usa la versión 24h que ya calcula el calendario
    },
    addMinutesLocal(fechaStr, minutosASumar) {
      const fecha = new Date(fechaStr.toString())
      let fechaNueva = fecha.setMinutes(fecha.getMinutes() + minutosASumar)
      let fechaFinal = new Date(fechaNueva).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' + new Date(fechaNueva).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      return fechaFinal
    },
    convertirFecha(fechaStr) {
      // Crear un objeto Date a partir de la cadena en formato "dd/MM/YYYY hh:mm p.m"
      const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}) (a\.m\.|p\.m\.)/;
      const matches = fechaStr.match(regex);
      
      if (!matches) {
        throw new Error("El formato de la fecha no es válido.");
      }

      const [_, dia, mes, año, horas, minutos, merid] = matches;

      // Crear un objeto Date con la fecha y hora
      let date = new Date(`${año}-${mes}-${dia}T${horas}:${minutos}:00`);

      // Ajustar la hora según el valor "p.m." o "a.m."
      if (merid === 'p.m.' && date.getHours() < 12) {
        date.setHours(date.getHours() + 12); // Convertir a 24 horas si es "p.m."
      }
      if (merid === 'a.m.' && date.getHours() === 12) {
        date.setHours(0); // Convertir las 12 a.m. a 00:00
      }

      // Formatear la fecha de salida en "YYYY-MM-DD hh:mm"
      const añoFormateado = date.getFullYear();
      const mesFormateado = String(date.getMonth() + 1).padStart(2, '0');
      const diaFormateado = String(date.getDate()).padStart(2, '0');
      const horasFormateado = String(date.getHours()).padStart(2, '0');
      const minutosFormateado = String(date.getMinutes()).padStart(2, '0');

      return `${añoFormateado}-${mesFormateado}-${diaFormateado} ${horasFormateado}:${minutosFormateado}`;
    },
    randomColor () {
      const colors = ['blue', 'red', 'green', 'purple', 'indigo', 'orange']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    sumarMinutos(time, minutos) {
      const fecha = new Date(time)
      fecha.setMinutes(fecha.getMinutes() + minutos)
      console.log('Nueva Fecha:', fecha)
      return fecha.toISOString().slice(0, 10)
    },
    getStatusColor(status) {
      const colors = {
        'PROGRAMADA': '#1976D2', // Blue
        'CONFIRMADA': '#0097A7', // Cyan/Teal
        'EN_SITIO': '#FFA000',   // Amber
        'EN_PROCESO': '#F57C00', // Orange
        'LIBERADA': '#7B1FA2',   // Purple
        'COMPLETADA': '#388E3C', // Green
        'CANCELADA': '#D32F2F'   // Red
      }
      return colors[status] || '#1976D2'
    },
    getStatusClass(status) {
      const classes = {
        'PROGRAMADA': 'programada-event',
        'CONFIRMADA': 'confirmada-event',
        'EN_SITIO': 'ensitio-event',
        'EN_PROCESO': 'enproceso-event',
        'LIBERADA': 'liberada-event',
        'COMPLETADA': 'completada-event',
        'CANCELADA': 'cancelada-event'
      }
      return classes[status] || 'programada-event'
    },
    isTimeExceeded(event) {
      if ((event.title !== 'EN_PROCESO' && event.title !== 'LIBERADA' && event.title !== 'COMPLETADA') || !event.start_time) return false
      const startTime = new Date(event.start_time)
      const endTime = (event.title === 'LIBERADA' || event.title === 'COMPLETADA') && event.end_time ? new Date(event.end_time) : new Date()
      const loadingTimeMinutes = event.loading_time_minutes || event.duration
      if (!loadingTimeMinutes) return false
      const diffMs = endTime - startTime
      const diffMinutes = diffMs / 60000
      return diffMinutes > loadingTimeMinutes
    },

    async fetchShipmentLoadData(windowId) {
      try {
        const config = {
          method: 'get',
          url: `https://empresa-service.intrare.app/shipments/shipment-loads/by-window/${windowId}/`,
          headers: {
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        const response = await axios(config)
        this.currentLoad = response.data
        if (this.currentLoad && this.currentLoad.id) {
          this.shipment_load_id = this.currentLoad.id
          this.formCarga.payroll_number = this.currentLoad.payroll_number || ''
          this.formCarga.notes = this.currentLoad.notes || ''
        }
        console.log('Datos de la carga actualizados:', this.currentLoad)
        return response.data
      } catch (error) {
        console.error('Error al obtener datos de la carga:', error)
        return null
      }
    },
    getMovimientoChipClass(status) {
      const classes = {
        'PROGRAMADA': 'chip-movimiento-programada',
        'CONFIRMADA': 'chip-movimiento-confirmada',
        'EN_SITIO': 'chip-movimiento-ensitio',
        'EN_PROCESO': 'chip-movimiento-enproceso',
        'LIBERADA': 'chip-movimiento-liberada',
        'COMPLETADA': 'chip-movimiento-completada',
        'CANCELADA': 'chip-movimiento-cancelada'
      }
      return classes[status] || 'chip-movimiento-programada'
    },
    getStatusIcon(status) {
      const icons = {
        'PROGRAMADA': 'event_note',
        'CONFIRMADA': 'event_available',
        'EN_SITIO': 'location_on',
        'EN_PROCESO': 'local_shipping',
        'LIBERADA': 'check_circle',
        'COMPLETADA': 'done_all',
        'CANCELADA': 'block'
      }
      return icons[status] || 'event'
    },
    getStatusDisplay(status) {
      const labels = {
        'PROGRAMADA': 'Programada',
        'CONFIRMADA': 'Confirmada',
        'EN_SITIO': 'En Sitio',
        'EN_PROCESO': 'En Proceso',
        'LIBERADA': 'Liberada',
        'COMPLETADA': 'Completada',
        'CANCELADA': 'Cancelada'
      }
      return labels[status] || status
    },
    getUnitStatusDisplay(status) {
      // Usar i18n para traducir estados de unidades activas
      const key = status ? status.toUpperCase() : 'UNKNOWN'
      const translation = this.$t(key)
      return translation !== key ? translation : status
    },
    getLoadingStatusDisplay(status) {
      // Traducir estados de carga (pueden estar en inglés como "NOT STARTED", "IN PROGRESS")
      if (!status) return status
      // Reemplazar espacios con guiones para buscar en i18n
      const key = status.replace(/\s+/g, '_')
      const translation = this.$t(key)
      return translation !== key ? translation : status
    },
    getToolbarClass(status) {
      const classes = {
        'PROGRAMADA': 'toolbar-programada',
        'CONFIRMADA': 'toolbar-confirmada',
        'EN_SITIO': 'toolbar-ensitio',
        'EN_PROCESO': 'toolbar-enproceso',
        'LIBERADA': 'toolbar-liberada',
        'COMPLETADA': 'toolbar-completada',
        'CANCELADA': 'toolbar-cancelada'
      }
      return classes[status] || 'toolbar-programada'
    },
    // REQ-006: Verificar si hay documentos pendientes
    hasPendingDocuments(event) {
      if (!this.enableAdvancedShipments) {
        return false
      }

      // Verificar en required_documents si hay documentos pendientes o expirados
      if (event.required_documents && event.required_documents.length > 0) {
        for (let doc of event.required_documents) {
          if (doc.completion_by_user && Object.keys(doc.completion_by_user).length > 0) {
            // Verificar si algún usuario tiene documentos pendiente o expirado
            for (let userId in doc.completion_by_user) {
              const userDoc = doc.completion_by_user[userId]
              if (userDoc.status === 'PENDIENTE' || userDoc.status === 'EXPIRADO') {
                return true
              }
            }
          }
        }
      }
      return false
    },
    getPendingDocuments() {
      return this.documentComparison.filter(doc => doc.status === 'PENDIENTE' || doc.status === 'EXPIRADO')
    },
    shouldShowEvent(event) {
      if (this.filtroTipoMovimiento === 'TODOS') {
        return true
      }
      // Si no tiene tipo_movimiento asignado, mostrar por defecto
      const tipoMovimiento = event.tipo_movimiento || 'EMBARQUE'
      return tipoMovimiento === this.filtroTipoMovimiento
    },
    // REQ-002: Métodos para indicadores visuales de tipo de movimiento
    getMovementBorderColor(event) {
      if (!this.enableAdvancedShipments || !event.tipo_movimiento) return 'transparent'
      return event.tipo_movimiento === 'EMBARQUE' ? '#FFA500' : '#2196F3'
    },
    getMovementClass(event) {
      if (!this.enableAdvancedShipments || !event.tipo_movimiento) return ''
      return 'movement-' + event.tipo_movimiento.toLowerCase()
    }
  }
}
</script>
<style scoped>
  .border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
  .border-right {
    border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
  .border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
  .pointer {
    cursor: pointer;
  }

  .date-display {
    transition: background-color 0.3s;
  }
  .date-display:hover {
    background-color: var(--v-primary-lighten4) !important;
  }

  .legend-box {
    width: 14px;
    height: 14px;
    border-radius: 3px;
  }

  .calendar-container-wrapper {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
  }

  .calendar-grid {
    min-width: 800px; /* Asegura que las columnas no se colapsen demasiado */
    display: flex;
    flex-wrap: nowrap;
  }

  .calendar-column {
    min-width: 150px;
    flex: 1 0 0%;
  }

  .calendar-header-title {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: #f8faff;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .custom-calendar-style {
    background-color: white !important;
  }

  .interval-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  }

  .my-event-folder {
    position: relative;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    padding-top: 20px; /* Space for the bigger tab */
  }

  .my-event-folder:hover {
    filter: brightness(1.1);
    transform: translateY(-2px);
    z-index: 11;
  }

  /* El tab de la carpeta */
  .folder-tab {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    padding: 2px 10px;
    font-size: 11px;
    font-weight: 800;
    color: white;
    display: flex;
    align-items: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
    white-space: nowrap;
    z-index: 2;
  }

  .folder-tab-text {
    letter-spacing: 0.5px;
  }

  /* El cuerpo principal de la carpeta */
  .folder-body {
    flex-grow: 1;
    border-radius: 0 6px 6px 6px;
    border-top-right-radius: 6px; /* Si la pestaña no ocupa todo */
    box-shadow: 0 2px 6px rgba(0,0,0,0.12);
    color: white;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .folder-content {
    padding: 6px 8px;
    width: 100%;
    height: 100%;
  }

  .event-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .programada-event {
    background: linear-gradient(135deg, #1976D2 0%, #64B5F6 100%);
    border: none;
  }

  .confirmada-event {
    background: linear-gradient(135deg, #0097A7 0%, #4DD0E1 100%);
    border: none;
  }

  .ensitio-event {
    background: linear-gradient(135deg, #FFA000 0%, #FFD54F 100%);
    border: none;
  }

  @keyframes blink {
    0% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(1.1); }
    100% { opacity: 1; transform: scale(1); }
  }

  .blink-alert {
    animation: blink 1.2s infinite ease-in-out;
  }

  .enproceso-event {
    background: linear-gradient(135deg, #F57C00 0%, #FFB74D 100%);
    border: none;
    animation: pulse-active 2s infinite;
  }

  .liberada-event {
    background: linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%);
    border: none;
  }

  .completada-event {
    background: linear-gradient(135deg, #388E3C 0%, #81C784 100%);
    border: none;
  }

  .cancelada-event {
    background: linear-gradient(135deg, #D32F2F 0%, #E57373 100%);
    border: none;
  }

  @keyframes pulse-active {
    0% {
      box-shadow: 0 0 0 0 rgba(245, 124, 0, 0.4);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(245, 124, 0, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(245, 124, 0, 0);
    }
  }

  .with-time {
    position: absolute;
    left: 4px;
    right: 4px;
  }

  /* Custom scrollbar */
  .calendar-container-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .calendar-container-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .calendar-container-wrapper::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
  .calendar-container-wrapper::-webkit-scrollbar-thumb:hover {
    background: #bbb;
  }

  /* Ocultar lineas de tiempo internas que no necesitamos si usamos intervalos personalizados */
  .theme--light.v-calendar-daily {
    border: none !important;
  }

  .info-grid {
    background-color: #f8faff;
    border-radius: 16px;
    padding: 20px;
  }

  .border-right-light {
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  .bg-light {
    background-color: #f5f7fa;
  }

  .border-light {
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
  }

  .premium-toolbar {
    letter-spacing: 0.5px;
  }

  /* Estilos para chips de tipo de movimiento con estados */
  .chip-movimiento-programada {
    background-color: #1976D2 !important;
    color: white !important;
    box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3) !important;
  }

  .chip-movimiento-confirmada {
    background-color: #0097A7 !important;
    color: white !important;
    box-shadow: 0 4px 8px rgba(0, 151, 167, 0.3) !important;
  }

  .chip-movimiento-ensitio {
    background: linear-gradient(135deg, #FFA000 0%, #FFD54F 100%) !important;
    color: #333 !important;
    box-shadow: 0 4px 8px rgba(255, 160, 0, 0.3) !important;
  }

  .chip-movimiento-enproceso {
    background: linear-gradient(135deg, #F57C00 0%, #FFB74D 100%) !important;
    color: white !important;
    box-shadow: 0 4px 8px rgba(245, 124, 0, 0.3) !important;
    animation: pulse-chip 2s infinite;
  }

  .chip-movimiento-liberada {
    background: linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%) !important;
    color: white !important;
    box-shadow: 0 4px 8px rgba(123, 31, 162, 0.3) !important;
  }

  .chip-movimiento-completada {
    background: linear-gradient(135deg, #388E3C 0%, #81C784 100%) !important;
    color: white !important;
    box-shadow: 0 4px 8px rgba(56, 142, 60, 0.3) !important;
  }

  .chip-movimiento-cancelada {
    background: linear-gradient(135deg, #D32F2F 0%, #E57373 100%) !important;
    color: white !important;
    box-shadow: 0 4px 8px rgba(211, 47, 47, 0.3) !important;
  }

  @keyframes pulse-chip {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }

  .chip-tipo-movimiento {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
    transition: all 0.2s ease !important;
  }

  .chip-tipo-movimiento:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
    transform: translateY(-2px);
  }

  /* Estilos para toolbar del modal con estados */
  .toolbar-programada {
    background-color: #1976D2 !important;
  }

  .toolbar-confirmada {
    background-color: #0097A7 !important;
  }

  .toolbar-ensitio {
    background-color: #FFA000 !important;
  }

  .toolbar-enproceso {
    background-color: #F57C00 !important;
  }

  .toolbar-liberada {
    background-color: #7B1FA2 !important;
  }

  .toolbar-completada {
    background-color: #388E3C !important;
  }

  .toolbar-cancelada {
    background-color: #D32F2F !important;
  }
</style>

<style>
  /* Global rules when full screen active */
  .hide-layout-elements-fullscreen .v-toolbar:not(.mockup-toolbar),
  .hide-layout-elements-fullscreen .v-navigation-drawer,
  .hide-layout-elements-fullscreen footer {
    display: none !important;
  }
  .hide-layout-elements-fullscreen .v-content {
    padding: 0 !important;
  }
</style>